import React from 'react';
import styled from 'styled-components';
import { ILessonOutlineCycleActivityExercise } from '../../../../types/lessonOutline';
import { positionLessonToString } from '../../../../helpers/positon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { CLIconWrapper } from './LessonOutlineActivityVoc';

export type IProps = {
  activity: ILessonOutlineCycleActivityExercise;
};

const LessonOutlineActivityExercise: React.FC<IProps> = (props) => {
  return (
    <Wrapper>
      {props.activity.repeated && (
        <CLIconWrapper>
          <FontAwesomeIcon icon={faExclamation} />
        </CLIconWrapper>
      )}
      {props.activity.position && <span>{positionLessonToString(props.activity.position.lesson)} - </span>}
      <span>{props.activity.id}</span>
    </Wrapper>
  );
};

export default LessonOutlineActivityExercise;

const Wrapper = styled.div`
  background-color: #ffdcdc;
  padding: 4px 2px;
  border-radius: 4px;
`;
